import axiosCall from './interceptor';
import URL from '../helper';

export const getTagsList = async () => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}getAllMRTagMapping`;
  let response = await axiosCall('get', url, null, true, false);
  return response.data;
};

export const getTagValues = async () => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}getTagValues`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const addTagMapping = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}addMRTagMapping`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const updateTagMapping = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}updateMRTagMapping`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};

export const deleteTagMapping = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}deleteMRTagMapping?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const changeDefaultPrinter = async id => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}setDefaultPrinter?id=${id}`;
  let response = await axiosCall('put', url);
  return response.data;
};

export const fetchAllPrinters = async () => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}fetchPrinter`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const addNewPrinter = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}addPrinter`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const deletePrinter = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}deletePrinter?printerId=${payload.id}`;
  const response = await axiosCall('delete', url);
  return response.data;
};

export const getDocumentsList = async (payload, tagList) => {
  const params = new URLSearchParams(payload);
  let url = `${URL.TRANSACTION_SYSTEM_URL}getMailRoomData?${params}`;
  let response = await axiosCall('post', url, tagList);
  return response.data;
};

export const createNewBatch = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}batch`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const validatePrinterConnection = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}connectPrinter`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const testPrintPage = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}testPrint`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const getBatchList = async payload => {
  const params = new URLSearchParams(payload);
  let url = `${URL.TRANSACTION_SYSTEM_URL}batch?${params}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getBatchDetails = async payload => {
  const params = new URLSearchParams(payload);
  let url = `${URL.TRANSACTION_SYSTEM_URL}mailroomDocuments?${params}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const rePrint = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}reprint`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteDocuments = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}removeDocuments`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};
